module.exports = __webpack_public_path__ + "img/TradingView-icon15_zh.ed6682c4.svg";